import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { GrowerOrderService } from './../../../services/seed/growerOrder.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { OrderTransferService } from './../../../services/seed/order-transfer.service';
import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { CommonService } from './../../../services/common/common.service';

import { MasterConstants } from '../../constants/master-constants';
import { AccountVM } from './../../../models/AccountMasterVM';
import { DashboardFilter } from './../../../models/DashboardFilter';
import { GrowerDealerOrderTransferVM } from '../../../models/GrowerDealerOrderTransferVM';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-diff-dealer-grower-order-transfer',
  templateUrl: './diff-dealer-grower-order-transfer.component.html',
  styleUrls: ['./diff-dealer-grower-order-transfer.component.scss']
})
export class DiffDealerGrowerOrderTransferComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  AccountId: any;
  toAccountNumber: number;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  maxlength = 50;
  dealerAccountList: any = [];
  dealerAccountId: any;
  fromDesiredDeliveryDate: any;
  customerPO: any;
  isGrowerSelected: any = false;
  dateFilter: any;
  activeCropYear: any;
  toDealerInfo: any = null;
  isReadOnly = true;
  fromGrower: any;
  toGrower: any;
  accountLoading: any;
  sellerId: any;
  accountEmail: any;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;

  accountInfo: AccountVM;
  orderFromTo: GrowerDealerOrderTransferVM = null;
  orderFromToList: GrowerDealerOrderTransferVM[] = [];
  dashboardFilter: DashboardFilter;

  // component variables at component initialize
  copyOrderFromToList: GrowerDealerOrderTransferVM[] = [];
  isTransfer = false;
  GrowerSearchSliderActive = false;
  sellerData: any;
  growerList: any[];
  toGrowerList: any[];

  toSellerId: any;
  selectedGrower: string;
  originalUnitCount = 0;
  modifiedUnitCount = 0;
  public SelectedAccountId: any;
  hasChangeAdded = false;
  isNotValid = false;
  errorMsgs = new Array();
  isSubscriptionAccess = true;

  constructor(
    public sliderModelService: SliderModelService,
    public matDialog: MatDialog,
    public loaderService: LoaderService,
    private router: Router,
    private growerOrderService: GrowerOrderService,
    private toastrService: ToastrService,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    private orderTransferService: OrderTransferService,
    private localStorageService: LocalStorageService,
    public commonService: CommonService,
    @Inject('BASE_URL') public baseUrl: any) {
    this.dashboardFilter = new DashboardFilter();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    // subscribe GMk value from grower search
    this.subscription.push(this.sliderModelService.gmkValue.subscribe(x => {
      if (x != 0) {
        this.selectedGrower = x;
        this.getGrowerAccount(this.dealerAccountId, true);
        // to fix multiple times slider open issue
        // this.sliderModelService.gmkValue.observers = [];
      }
    }));
  }

  ngOnInit() {
    // load header crop year and company code
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
      }
    }

    // Get Active CropYear
    if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
      this.activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    }
    this.validateDateFilter();
    this.getdealerAccountList();

    // Need to validate use
    this.subscription.push(this.sliderModelService.selectedGrowerAccId.subscribe(x => {
      this.AccountId = +x;
    }));

    this.subscription.push(this.sliderModelService.SelectedAccountId.subscribe(x => {
      this.SelectedAccountId = +x;
    }));

    this.subscription.push(this.sliderModelService.g2gUnit.subscribe(x => {
      this.bindOrderTransferList(x);
    }));

    this.sliderModelService.g2gUnit.observers = [];

    // If header dropdown value exist
    if (this.headerCompany && this.headerYear) {
      this.getAccountInfo(this.AccountId);
      this.getGrowerAccount(this.AccountId, false);
    }
  }

  // Get Dealer Account List
  getdealerAccountList() {
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.companyCode = this.headerCompany;
    this.subscription.push(this.growerOrderService.getAccounts().subscribe(result => {
      this.dealerAccountList = result;
      let account = this.dealerAccountList.find(x => x.accountNumber == this.AccountId);
      this.dealerAccountList = this.dealerAccountList.filter(x => x.accountNumber != this.AccountId);
      let ribStatus = false;
      if (this.orderFromToList) {
        const hasTrue = this.orderFromToList.some(element => element.isRib === true);
        const hasFalse = this.orderFromToList.some(element => element.isRib === false);

        if (hasTrue == false && hasFalse == true) {
          ribStatus = true;
        }
      }
      
      this.dealerAccountList.forEach(x => {
        x.isValidAccount = !(x.isRibState == true && ribStatus === true);
      });

      //Disabled Invalid options
      this.dealerAccountList = this.dealerAccountList.map((p) =>
        p.isValidAccount ? p : { ...p, disabled: true }
      );

    }, error => LolLoggerService.error(error)));
  }

  // get to dealer availibility on To Dealer selection
  selectToDealer(toDealer) {
    this.resetToDealerData();

    if (toDealer) {
      if (toDealer.billingAddressType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
        // this.toDealer = toDealer;
        this.isTransfer = true;
        // this.toAccountNumber = 0;
        // if (toDealer.shipToAccount) {
        //     this.toAccountNumber = toDealer.shipToAccount;
        // }

        const data = {
          CompanyCode: this.headerCompany,
          CropYear: this.headerYear,
          FromAccountNumber: this.orderFromToList.find(x => x.FromShipToAccount > 0).FromShipToAccount,
          ToAccountNumber: toDealer.accountNumber,
          ItemNumbers: this.orderFromToList.map(x => x.ItemNumber)
        };

        this.subscription.push(this.orderTransferService.getAllocationAvailability(data).subscribe((result: any) => {
          if (result && result.status) {
            this.orderFromToList.forEach(item => {
              const matchItem = result.resultData.find(x => x.itemNumber == item.ItemNumber);
              if (matchItem) {
                item.ToShipToAccount = toDealer.accountNumber;
                item.TransferableUnitsDO = matchItem.transferableUnits;
                item.RemainingQuantityDO = item.TransferableUnitsDO < +item.OriginalFromQty ? +item.TransferableUnitsDO : +item.OriginalFromQty;
                item.DealerModifiableUnits = item.DealerModifiableUnits;
                // Update to round of ConvFactor
                this.orderFromTo.RemainingQuantityDO = parseInt((+item.RemainingQuantityDO / +item.Conv).toString()) * item.Conv;// Bug 49041
                item.RemainingQuantityDO = this.orderFromTo.RemainingQuantityDO;// G1D1/G2D2 - Display of remaining quantity for items sold in MB after TO account and TO grower are selected (test case 65) made these 2 changes
              }
              if (toDealer.isRibState) {
                if (item.isRib) {
                  item.isValidForRibTransfer = true;
                }
                else {
                  item.isValidForRibTransfer = false;
                }
              }
              else {
                item.isValidForRibTransfer = true;
              }
            });

            // clone modified object
            this.cloneTransferListObj(this.orderFromToList);
            this.calculateTotalUnitTransfer();
          }
          else {
            if (result) {
              this.toastrService.info(result.message);
            }
            else {
              this.toastrService.error('No Record Found.');
            }
          }
        }, (error => {
          LolLoggerService.error(error);
        })));
      }
      else {
        this.isTransfer = false;
        this.resetToDealerData();
        this.calculateTotalUnitTransfer();
        this.toastrService.warning('Account not eligible for Ordering.');
      }
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { transferTarget: true });
    }
    else {
      this.isTransfer = false;
      this.resetToDealerData();
    }
  }

  // To show hide product deactivation info block
  blockHideShow(id: number, flag: boolean) {
    if (flag) {
      $('#sub_' + id).addClass('showHide');
      $('#main_' + id).addClass('prod-unavail-info-hover');
    }
    else {
      $('#sub_' + id).removeClass('showHide');
      $('#main_' + id).removeClass('prod-unavail-info-hover');
    }
  }

  // reset to dealer order data
  resetToDealerData() {
    this.orderFromToList.forEach(item => {
      // reset values to 0
      item.ToPrimaryQtyDO = 0;
      item.ToSecondaryQtyDO = 0;
      item.TransferableUnitsDO = 0;
      item.RemainingQuantityDO = 0;
      item.LineErrors = { 'rowId': item.rowId, 'errors': [] };
    });
  }

  // Dealer dropdown Account Search method
  dealerAccountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Set Grower data based on account selection
  setGrowerBasedOnDealer(accountDetails) {
    if (accountDetails) {
      this.toGrower = null;
      this.toSellerId = null;
      this.selectedGrower = null;
      this.sellerData = [];
      this.orderFromToList.forEach(x => {
        x.ToPrimaryQtyGO = 0;
      });
      this.getGrowerAccount(accountDetails.accountNumber, true);
      this.getSellerList(accountDetails.accountNumber);
      this.selectToDealer(accountDetails);
      this.toDealerInfo = accountDetails;
      this.isReadOnly = true;
      this.toAccountNumber = accountDetails.accountNumber;
    }
    else {
      this.toDealerInfo = null;
      this.toGrowerList = [];
      this.sellerData = [];
      this.toGrower = null;
      this.selectedGrower = null;
      this.toSellerId = null;
      this.isReadOnly = true;
    }
  }

  // Reset remaining qunatity of products when dealer/grower is cleared
  resetRemainingQty() {
    this.orderFromToList.forEach(x => {
      x.ToPrimaryQtyGO = 0;
      this.validateLineItem(x, 'growerUnits');
    });
    this.calculateTotalUnitTransfer();
  }

  // Get grower List
  getGrowerAccount(accountNo: number, isToGrower: boolean) {
    if (!isNaN(accountNo)) {
      this.dashboardFilter.cropYear = this.headerYear;
      this.dashboardFilter.shipToAccount = +accountNo;
      const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
      this.subscription.push(this.growerOrderService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
        this.growerList = result as any[];
        if (this.growerList && this.growerList.length > 0) {
          // TODO: Sumit - GMK
          this.growerList.forEach(grower => {
            grower.businessName = (grower.businessName == null || grower.businessName == '' ?
              (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
              (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
              (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
              : grower.businessName);
          });

          // add for auto select from search grower slider
          if (this.sliderModelService.GrowerSearchSliderActive.value) {
            const data = this.growerList.filter(x => x.gmk == this.selectedGrower);
            if (data[0]) {
              this.selectToGrower(data[0]);
            }
            else {
              this.selectToGrower(null);
            }
          }
          this.sliderModelService.GrowerSearchSliderActive.next(false);

          if (isToGrower) {
            this.toGrowerList = this.growerList;
          }
          if (!isToGrower) {
            this.fromGrower = this.growerList.find(x => x.gmk === this.orderFromToList[0].FromGMK
              && x.growerOrderList.length > 0 && x.growerOrderList[0].orderNumber === this.orderFromToList[0].FromOrderNoGO);
          }
        }
        else {
          this.toGrowerList = [];
        }
      }, error => LolLoggerService.error(error)));
    }
  }

  // Get All seller list based on dealer account selection
  getSellerList(accountNumber) {
    this.subscription.push(this.growerOrderService.getSellerList(accountNumber).subscribe(result => {
      this.sellerData = result;
    }, error => { LolLoggerService.error(error); }));
  }

  // Validate email id
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { emailUpdated: true });
    if (!this.isNotValid) {
      this.copyOrderFromToList.forEach(x => {
        x.EmailTo = this.accountEmail;
      });
    }
    return this.isNotValid;
  }

  indiviualEmailValidation() {
    const emailList = this.accountEmail?.split(';');
    let isValid = false;
    if (emailList.length > 0) {
      emailList.map((x) => {
        if (this.individualEmailPattern.test(x)) {
          isValid = true;
        }
        else {
          isValid = false;
        }
      });
    }
    if (!isValid) {
      this.toastrService.error('Enter a valid email.');
      return false;
    }
    else {
      return true;
    }
  }

  // Get Account Info
  getAccountInfo(accountNumber: number) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.growerOrderService.getAccountInfo(this.headerYear, accountNumber).subscribe((result: any) => {
      this.accountInfo = result;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // validate date
  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);

      const calendarDate = d;// .getDate();
      let maxDate = new Date();
      if (this.activeCropYear) {
        maxDate = new Date(this.activeCropYear.endDate);
      }
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate && calendarDate <= maxDate;
    };
  }

  // Search Seller function
  sellerSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // get call on seller change
  SellerChange($event) {
    if ($event != null && $event.accountNumber > 0) {
      this.toSellerId = $event.accountNumber;
      this.orderFromToList.forEach(x => {
        if (this.toSellerId > 0) {
          x.ToSellerId = this.toSellerId;
        }
      });
    }
    else {
      this.toSellerId = null;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { sellerUpdate: true });
  }

  // filter function
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.growerName.toLocaleLowerCase().indexOf(term) > -1;
  }

  // filter function
  toGrowerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    // TODO: Sumit - GMK
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // Qty change on +/- sign click
  geuValueChange(action: string, productItem: any) {
    const g2gItem = this.orderFromToList.find(x => x.rowId == productItem.rowId);
    const index = this.orderFromToList.findIndex(x => x.rowId == productItem.rowId);
    if (g2gItem && index != -1) {
      if (action == 'decrease') {
        if ((+productItem.ToPrimaryQtyGO) > (+productItem.RemainingQuantityDO)) {
          productItem.ToPrimaryQtyGO = productItem.RemainingQuantityDO;
        }
        else {
          if ((Math.ceil(+productItem.ToPrimaryQtyGO / +productItem.Conv) * productItem.Conv - productItem.Conv) >= 0) {
            const valueBeforeDec = +productItem.ToPrimaryQtyGO;
            productItem.ToPrimaryQtyGO = Math.floor(+productItem.ToPrimaryQtyGO / +productItem.Conv) * +productItem.Conv;
            // update correct values to variable after rounding to conv factor
            const conValue = Math.abs((+productItem.ToPrimaryQtyGO) - (+productItem.Conv));
            if (+productItem.RemainingQuantityDO >= conValue && +productItem.RemainingQuantityDO < +productItem.Conv) {
              productItem.ToPrimaryQtyGO = +productItem.RemainingQuantityDO;
            }
            else if (valueBeforeDec == +productItem.ToPrimaryQtyGO) {
              // decrease value for ToDealer
              productItem.ToPrimaryQtyGO = Math.abs((+productItem.ToPrimaryQtyGO) - (+productItem.Conv));
            } else {
              productItem.ToPrimaryQtyGO = Math.abs((+productItem.ToPrimaryQtyGO));
            }
            productItem.ToQty = +productItem.ToPrimaryQtyGO;
            // Scenario to handle when switching of value is done from manual entering and button pressing remaining quantity differ
            if (+productItem.FromPrimaryQtyGO > 0 && (+productItem.FromPrimaryQtyGO % (+productItem.Conv) == 0)) {
              // increase value for FromDealer
              productItem.FromPrimaryQtyGO = Math.abs((+productItem.FromPrimaryQtyGO) + (+productItem.Conv));
              productItem.FromQtyGO = +productItem.FromPrimaryQtyGO;
            } else {
              productItem.FromPrimaryQtyGO = Math.abs((+productItem.RemainingQuantityDO) - (+productItem.ToPrimaryQtyGO));
              productItem.FromQtyGO = +productItem.FromPrimaryQtyGO;
            }

            // update to show modified units
            if (productItem.ToPrimaryQtyGO > 0) {
              productItem.FromModifyQtyGO = productItem.FromPrimaryQtyGO;
            }
            else {
              productItem.FromModifyQtyGO = 0;
            }
          }
        }
        productItem.FromPrimaryQty = Math.abs((+productItem.RemainingQuantityDO) - (+productItem.ToPrimaryQtyGO));
        productItem.FromQty = +productItem.FromPrimaryQty;
      }
      if (action == 'increase') {
        if (+productItem.RemainingQuantityDO <= +productItem.ToPrimaryQtyGO) {
          productItem.ToPrimaryQtyGO = +productItem.RemainingQuantityDO;
        }
        else if (+productItem.FromPrimaryQtyGO > 0 && (((+productItem.FromPrimaryQtyGO) - (+productItem.Conv) >= 0) ||
          (Math.ceil(+productItem.ToPrimaryQtyGO / +productItem.Conv) * +productItem.Conv <= +productItem.RemainingQuantityDO)) && +productItem.FromPrimaryQtyGO % (+productItem.Conv) == 0) {
          var valueBeforeInc = +productItem.ToPrimaryQtyGO;

          productItem.ToPrimaryQtyGO = Math.ceil(+productItem.ToPrimaryQtyGO / +productItem.Conv) * +productItem.Conv;
          // update correct values to variable after rounding to conv factor
          if (valueBeforeInc == +productItem.ToPrimaryQtyGO) {
            // increase value for ToGrower
            productItem.ToPrimaryQtyGO = Math.abs((+productItem.ToPrimaryQtyGO) + (+productItem.Conv));
          }
          else { (valueBeforeInc > +productItem.ToPrimaryQtyGO); }
          {
            productItem.ToPrimaryQtyGO = Math.abs((+productItem.ToPrimaryQtyGO));
          }

          productItem.ToQty = +productItem.ToPrimaryQtyGO;
        }
        else if (+productItem.RemainingQuantityDO >= +productItem.ToPrimaryQtyGO) {
          var valueBeforeInc = +productItem.ToPrimaryQtyGO;
          const convValue = Math.floor(+valueBeforeInc / +productItem.Conv);

          if (valueBeforeInc < +productItem.Conv && +productItem.RemainingQuantityDO < +productItem.Conv) {
            productItem.ToPrimaryQtyGO = +productItem.RemainingQuantityDO;
          }
          else if (valueBeforeInc < +productItem.Conv && +productItem.RemainingQuantityDO > +productItem.Conv) {
            productItem.ToPrimaryQtyGO = +productItem.Conv;
          }
          else {
            productItem.ToPrimaryQtyGO = +productItem.Conv * +convValue;
          }

          // productItem.ToPrimaryQty = +productItem.RemainingQuantityDO;
          productItem.ToPrimaryQtyGO = Math.abs((+productItem.ToPrimaryQtyGO));
          productItem.ToQty = +productItem.ToPrimaryQtyGO;
        }
        productItem.FromPrimaryQtyGO = Math.abs((+productItem.RemainingQuantityDO) - (+productItem.ToPrimaryQtyGO));
        productItem.FromQtyGO = +productItem.FromPrimaryQtyGO;
        productItem.FromModifyQtyGO = +productItem.FromPrimaryQtyGO;
      }

      this.validateLineItem(productItem, 'growerUnits');
      this.orderFromToList[index] = JSON.parse(JSON.stringify(productItem));
      // calculat total unit transfer
      this.calculateTotalUnitTransfer();
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.orderFromToList.length });
      // clone modified object
      if (productItem.LineErrors.errors.length <= 0) {
        this.cloneTransferListObj(this.orderFromToList);
      }
    }
  }

  // Validate Selected Count
  validateSelectedCount(element, g2gUnits: number) {
    const g2gItemOld = this.copyOrderFromToList.find(x => x.rowId == element.rowId);
    const g2gItem = this.orderFromToList.find(x => x.rowId == element.rowId);
    const index = this.orderFromToList.findIndex(x => x.rowId == element.rowId);
    if (g2gItem && g2gItemOld && index != -1) {
      // get change value to calculate FromGrower qty
      const changedValue = +g2gUnits - (+g2gItemOld.ToPrimaryQtyGO);
      //  if (+g2gUnits <= +g2gItemOld.OriginalFromQty) {
      // update ToGrower qty
      g2gItem.ToPrimaryQtyGO = +g2gUnits;
      g2gItem.ToQty = +g2gUnits;

      if (+changedValue >= 0) {
        // update FromGrower qty
        g2gItem.FromPrimaryQtyGO = Math.abs(+g2gItem.FromPrimaryQtyGO - (+changedValue));
        g2gItem.FromQtyGO = +g2gItem.FromPrimaryQtyGO;
      }
      else {
        // increase FromGrower qty
        g2gItem.FromPrimaryQtyGO = Math.abs(+g2gItem.FromPrimaryQtyGO) + Math.abs(+changedValue);
        g2gItem.FromQtyGO = +g2gItem.FromPrimaryQtyGO;
      }
      // update to show modified units
      if (+g2gItem.ToPrimaryQtyGO > 0) {
        g2gItem.FromModifyQtyGO = +g2gItem.FromPrimaryQtyGO;
      }
      else {
        g2gItem.FromModifyQtyGO = 0;
      }
      // }
      // else {
      //  g2gItem.ToPrimaryQty = +g2gItemOld.ToPrimaryQty;
      // }
      this.validateLineItem(g2gItem, 'growerUnits');
      this.orderFromToList[index] = JSON.parse(JSON.stringify(g2gItem));
      // clone modified object
      if (g2gItem.LineErrors.errors.length <= 0) {
        this.cloneTransferListObj(this.orderFromToList);
      }
      this.calculateTotalUnitTransfer();
    }
  }

  // Bind Order Transfer List
  bindOrderTransferList(orderList) {
    // initial data binding
    this.orderFromToList = [];
    orderList.forEach(item => {
      // To get only date part

      const desiredDate = item.desiredDeliveryDate.toString();

      this.orderFromTo = new GrowerDealerOrderTransferVM();
      this.orderFromTo.CropYear = this.headerYear;
      this.orderFromTo.CompanyCode = this.headerCompany;
      this.orderFromTo.FromShipToAccount = item.shipToAccount;
      this.orderFromTo.ToShipToAccount = item.shipToAccount;
      this.orderFromTo.ItemId = item.itemID;
      this.orderFromTo.ItemNumber = item.itemNumber;
      this.orderFromTo.ItemDescription = item.itemDescription;
      this.orderFromTo.Brand = item.brand;
      this.orderFromTo.MarketingBrand = item.marketingBrand;
      this.orderFromTo.OriginalFromQty = item.geu;
      this.orderFromTo.FromModifyQtyGO = 0;
      this.orderFromTo.FromPrimaryQtyGO = item.geu;
      this.orderFromTo.FromDeliveryDate = desiredDate;
      this.orderFromTo.FromCustomerPO = item.customerPO;
      this.orderFromTo.FromGMK = item.growerGMK;
      this.orderFromTo.FromOrderIdGO = item.growerOrderID;
      this.orderFromTo.FromOrderItemIdGO = item.growerOrderItemId;
      this.orderFromTo.FromOrderNoGO = item.growerOrderNumber;
      this.orderFromTo.PrimaryUom = item.primaryUOM;
      this.orderFromTo.Conv = item.conv;
      this.orderFromTo.ToPrimaryQtyGO = 0;
      this.orderFromTo.ToSecondaryQtyGO = 0;
      this.orderFromTo.ToQty = 0;
      this.orderFromTo.rowId = item.rowId;
      this.orderFromTo.ToOrderIdGO = 0;
      this.orderFromTo.ToOrderNoGO = '';
      this.orderFromTo.ToSellerId = 0;
      this.orderFromTo.ToCustomerPO = '';
      this.orderFromTo.ToDeliveryDate = desiredDate;
      this.orderFromTo.LineErrors = item.lineErrors;
      this.orderFromTo.FromChangeType = 'TGF';
      this.orderFromTo.ToChangeType = 'TGT';
      this.orderFromTo.EmailTo = this.accountEmail;
      this.orderFromTo.TransferableUnitsDO = item.transferableUnits;
      this.orderFromTo.DealerModifiableUnits = item.dealerModifiableUnits;
      this.orderFromTo.SoftCommitUnits = item.softCommitUnits;
      this.orderFromTo.seedNonReturnable = item.seedNonReturnable;
      this.orderFromTo.isRib = item.isRib;
      this.orderFromTo.isValidForRibTransfer = true;
      this.orderFromTo.RemainingQuantityDO = (+item.dealerModifiableUnits + +item.softCommitUnits) < +this.orderFromTo.OriginalFromQty ? +(+item.dealerModifiableUnits + +item.softCommitUnits) : +this.orderFromTo.OriginalFromQty;
      // Update to round of ConvFactor
      this.orderFromTo.RemainingQuantityDO = parseInt((+this.orderFromTo.RemainingQuantityDO / +this.orderFromTo.Conv).toString()) * this.orderFromTo.Conv;

      const index = this.orderFromToList.findIndex(x => x.ItemId == item.itemID);
      if (index !== -1) {
        this.orderFromToList[index].OriginalFromQty = this.orderFromToList[index].OriginalFromQty + item.geu;
        this.orderFromToList[index].RemainingQuantityDO = +item.dealerModifiableUnits < +this.orderFromToList[index].OriginalFromQty ? +item.dealerModifiableUnits : +this.orderFromToList[index].OriginalFromQty;

        if (this.orderFromToList[index].ToDeliveryDate > desiredDate) { this.orderFromToList[index].ToDeliveryDate = desiredDate; }
        this.orderFromToList[index].FromOrderItemIdsGO.push(item.growerOrderItemId);
      }
      else {
        this.orderFromTo.FromOrderItemIdsGO.push(item.growerOrderItemId);
        this.orderFromToList.push(this.orderFromTo);
      }
    });

    this.cloneTransferListObj(this.orderFromToList);
    this.calculateTotalUnitTransfer();// Bug #49192 G1D1/G2D2 - Transferred Units in the Bottom Right of the Screen
  }

  // Clone Transfer List Obj
  cloneTransferListObj(orderList) {
    this.copyOrderFromToList = JSON.parse(JSON.stringify(orderList));
  }

  confirmToTransfer() {
    const softCommitUsedList = this.orderFromToList.filter(x => x.ToPrimaryQtyGO > x.DealerModifiableUnits);
    // display confirm message if any of the items using soft commit unit
    if (softCommitUsedList && softCommitUsedList.length > 0) {
      const title = 'Confirm';
      let rows = '';
      softCommitUsedList.forEach(element => {
        rows += '<tr class="mat-row">';
        rows += '<td class="mat-cell">' + element.ItemNumber + '</td>';
        rows += '<td class="mat-cell">' + element.ItemDescription + '</td>';
        rows += '</tr>';
      });
      const message = `<p>The following products are being packaged, and cannot be modified after transfer is complete:</p>
            <div class="row">
                <div class="col-md-12 padding-r0">
                    <div class="tableContainer">
                        <table class="matTables mat-table">
                            <thead>
                                <tr class="mat-header-row">
                                    <th class="mat-header-cell">Item number</th>
                                    <th class="mat-header-cell">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>`;
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, htmlMessage: message, labelYes: 'OK to continue', labelNo: 'Cancel', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected ok
        if (result == true) {
          this.transferUnits();
          // this.sliderModelService.close();
        }
      }));
    }
    else {
      this.transferUnits();
    }
  }

  // Save Changes - Transfer the Grower Order Items
  transferUnits() {
    if (!this.validateEmail()) {
      if (this.orderFromToList.filter(x => x.ToPrimaryQtyGO != 0).length > 0) {
        this.orderFromToList[0].EmailTo = this.accountEmail;
        this.orderFromToList.forEach(item => {
          item.ToShipToAccount = this.dealerAccountId;
          item.ToCustomerPO = this.customerPO;
          item.ToDeliveryDateForCalendar = item.ToDeliveryDate;
          item.ToDeliveryDate = (new Date(item.ToDeliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
          item.FromDeliveryDate = (new Date(item.FromDeliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
        });

        if (this.validateG2GTransfer()) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.push(this.orderTransferService.transferGrowerOrderToDifferentDealer(this.orderFromToList.filter(x => x.ToPrimaryQtyGO != 0)).subscribe((result: any) => {
            if (result && result.toOrderIdGO && result.toOrderIdGO != 0) {
              this.toastrService.success('Your order has been saved');
              const growerOrderId = result.toOrderIdGO as number;
              this.sliderModelService.close();
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
              this.router.navigate(['/orders/grower-order-detail', 0, +growerOrderId]);
            }
            else {
              this.orderFromToList.forEach(data => {
                data.ToDeliveryDate = data.ToDeliveryDateForCalendar;
                data.LineErrors.errors = [];
                const itemErrors = result.dealerOrderItems.find(result => result.itemNumber == data.ItemNumber);
                if (itemErrors) {
                  itemErrors.errors.forEach(itemError => {
                    data.LineErrors.errors.push({ id: itemError.id, error: itemError.error });
                    if (data.LineErrors.errors.length > 0) {
                      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != data.rowId);
                      this.errorMsgs.push(data.LineErrors);
                    }
                  });
                }
              });
            }
            this.loaderService.setLoaderStatus(false);
          }, (error => {
            this.loaderService.setLoaderStatus(false);
            LolLoggerService.error(error);
            this.sliderModelService.close();
            this.toastrService.error('Something went wrong!');
          })));
        }
      }
    }
    else {
      this.toastrService.warning('Enter a valid email.');
    }
  }
  // validate Transfer
  validateG2GTransfer() {
    return true;
  }

  // Calculate Total Unit Transfer
  calculateTotalUnitTransfer() {
    this.originalUnitCount = this.orderFromToList.reduce((sum, item) => sum + +item.RemainingQuantityDO, 0);// Bug #49192 G1D1/G2D2 - Transferred Units in the Bottom Right of the Screen
    this.modifiedUnitCount = this.orderFromToList.reduce((sum, item) => sum + +item.ToPrimaryQtyGO, 0);
  }

  // Select To Grower
  selectToGrower(toGrower) {
    if (toGrower) {
      this.isGrowerSelected = true;
      this.toGrower = toGrower;
      this.isTransfer = true;
      this.isReadOnly = false;
      this.orderFromToList.forEach(x => {
        x.ToGLN = toGrower.growerGLN;
        x.ToGMK = toGrower.gmk;
        if (toGrower.growerOrderList.length > 0) {
          x.ToOrderIdGO = toGrower.growerOrderList[0].growerOrderID;
          x.ToOrderNoGO = toGrower.growerOrderList[0].orderNumber;
        }
      });
    }
    else {
      this.isReadOnly = true;
      this.isGrowerSelected = false;
      this.toGrower = null;
      this.selectedGrower = null;
      this.isTransfer = false;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { transferTarget: true });
  }

  // Cancel
  onCancel() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          this.sliderModelService.close();
        }
      }));
    }
    else { this.sliderModelService.close(); }
  }

  // Open Search Grower Slider
  openSearchGrowerSlider() {
    this.sliderModelService.GrowerSearchSliderActive.next(true);
    this.subscription.push(this.sliderModelService.GrowerSearchSliderActive.subscribe(data => {
      this.GrowerSearchSliderActive = data;
    }));

    this.sliderModelService.newGrowerOrderSliderClose.next(true);
    /*this.sliderModelService.growerSearchType.next('OTHER_DEALER_TFR');*/
    this.sliderModelService.toAccountNumber.next(this.toAccountNumber);
  }

  // Line item validation
  validateLineItem(item: any, validateField) {
    if (validateField != '') {
      if (validateField == 'growerUnits') {
        if (+item.RemainingQuantityDO - +item.ToPrimaryQtyGO < 0) {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'growerUnits');
          item.LineErrors.errors.push({
            id: 'growerUnits', error: 'Cannot increase the quantity more than transferable units. ' + item.RemainingQuantity + ' Equivalent Units remaining.'
          });
        }
        else {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'growerUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);

          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'conv');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);

          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'dealerUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
      }
    }
    if (item.LineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.LineErrors);
    }
    if (this.errorMsgs.length > 0) {
      this.isTransfer = false;
    }
    else if (this.toGrower) {
      this.isTransfer = true;
    }
    else {
      this.isTransfer = false;
    }
    return item;
  }

  // Destroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
